// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const CustomPaginationContainer = ({
  handlePageChange,
  total,
  startEntry,
  endEntry,
  currentPage,
  visiblePages,
  totalPages,
}) => {
  console.log("svniosenvesvse", visiblePages);
  return (
    <div
      className="dataTables_paginate paging_simple_numbers"
      id="example5_paginate"
    >
      <Link
        className="paginate_button previous disabled"
        //   to="/table-datatable-basic"
        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
      >
        <i className="fa fa-angle-double-left" aria-hidden="true"></i>
      </Link>
      <span>
        {visiblePages.map((page, index) =>
          page === "start-ellipsis" || page === "end-ellipsis" ? (
            <span key={page} className={`paginate_button`}>
              …
            </span>
          ) : (
            <Link
              key={page + 1}
              //   to="/table-datatable-basic"
              className={`paginate_button  ${
                currentPage === page + 1 ? "current" : ""
              } `}
              onClick={() => handlePageChange(page + 1)}
            >
              {page + 1}
            </Link>
          )
        )}
      </span>
      <Link
        className="paginate_button next"
        //   to="/table-datatable-basic"
        onClick={() =>
          currentPage < totalPages && handlePageChange(currentPage + 1)
        }
      >
        <i className="fa fa-angle-double-right" aria-hidden="true"></i>
      </Link>
    </div>
  );
};

export default CustomPaginationContainer;
